import { render } from "./DeliveryPickupLocationOverview.vue?vue&type=template&id=582031a0&scoped=true&ts=true"
import script from "./DeliveryPickupLocationOverview.vue?vue&type=script&lang=ts"
export * from "./DeliveryPickupLocationOverview.vue?vue&type=script&lang=ts"

import "./DeliveryPickupLocationOverview.vue?vue&type=style&index=0&id=582031a0&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-582031a0"]])

export default __exports__